import { useEffect } from 'react'

import { fetchPropertyOfferMap } from 'actions/OfferActions'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_BED_BANK } from 'constants/offer'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'

type Return = [
  mapping: App.PropertyOfferMapping | undefined,
  fetching: boolean,
  error: any,
]

function usePropertyOfferMapping(
  offerType: typeof OFFER_TYPE_ALWAYS_ON | typeof OFFER_TYPE_BED_BANK,
  offerId: string | undefined = '',
  options: { disabled?: boolean } = {},
): Return {
  const dispatch = useAppDispatch()

  const mapping = useAppSelector(state => state.offer.propertyOfferMappings[offerId])

  const isFetchRequired = !!offerId && !options.disabled && !mapping
  useEffect(() => {
    if (isFetchRequired) {
      dispatch(fetchPropertyOfferMap(offerType, offerId))
    }
  }, [dispatch, isFetchRequired, offerId, offerType])

  if (options.disabled) return [undefined, false, undefined]
  return [
    mapping?.mapping,
    mapping?.fetching ?? isFetchRequired,
    mapping?.error,
  ]
}

export default usePropertyOfferMapping
